import React from "react"
import Img from "gatsby-image"
import { FaLinkedin } from "react-icons/fa"
import { SiGooglescholar } from "react-icons/si"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import Typography from "@material-ui/core/Typography"
import Grid from "@material-ui/core/Grid"

// core components
import Card from "./card/Card"
import CardAvatar from "./card/CardAvatar"
import CardBody from "./card/CardBody"

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "300",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  nodisplay: {
    display: "none",
  },

  iconLinks: {
    display: "flex",
    gap: "20px", // increased spacing between icons
    marginTop: "12px",
    alignItems: "center",
  },

  iconLink: {
    color: "#ff7043", // your hex color
    textDecoration: "none",
    transition: "opacity 0.2s ease",
    "&:hover": {
      opacity: 0.75, // subtle hover instead of color change
    },
  },

  alignVerticalHorizontal: {
    "@media (max-width: 1280px)": {
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
    },
  },
}

function Avatar(props) {
  const { classes } = props
  return (
    <div>
      <Card profile>
        <Grid container justify="flex-start" alignItems="center">
          <Grid item xs={12} sm={12} lg={6}>
            <div className={classes.alignVerticalHorizontal}>
              <CardAvatar profile>
                <Img
                  fixed={props.ImgData.childImageSharp.fixed}
                  alt="Lucas M. Silva"
                />
              </CardAvatar>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <CardBody profile style={{ textAlign: "left" }}>
              <Typography color="secondary" gutterBottom>
                Assistant Professor
              </Typography>
              <Typography color="secondary" gutterBottom>
                Computer Science Department
              </Typography>
              <Typography color="secondary" gutterBottom>
                University of Iowa
              </Typography>
              <Typography color="secondary" gutterBottom>
                <em>lucas-silva [at] uiowa.edu</em>
              </Typography>
              <div className={classes.iconLinks}>
                <a
                  href="https://www.linkedin.com/in/lucas-m-silva-91119825/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.iconLink}
                  aria-label="LinkedIn profile"
                >
                  <FaLinkedin size={28} />
                </a>

                <a
                  href="https://scholar.google.com/citations?user=wr-fjOgAAAAJ&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.iconLink}
                  aria-label="Google Scholar profile"
                >
                  <SiGooglescholar size={28} />
                </a>
              </div>
            </CardBody>
          </Grid>
        </Grid>
      </Card>
    </div>
  )
}

export default withStyles(styles)(Avatar)
